import { Paper } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import WarningContent from './WarningContent'

interface RetrofitNotAvailableProps {
  isFarmMaster?: boolean
  isUnknown?: boolean
}

/**
 * Component to display, when there is no retrofit option for a system
 */
const RetrofitNotAvailable: React.FC<RetrofitNotAvailableProps> = ({ isFarmMaster, isUnknown }) => {
  return (
    <Paper sx={{ p: 4 }}>
      <Box
        sx={theme => ({
          px: 4,
          py: 2,
          backgroundColor: theme.palette.grey.grey07,
          borderRadius: 2,
          border: `1px solid ${theme.palette.grey.grey06}`,
        })}
      >
        <WarningContent isFarmMaster={!!isFarmMaster} isUnknown={!!isUnknown} />
      </Box>
    </Paper>
  )
}

export default RetrofitNotAvailable
